// console.log(`search.js is working`);

const searchButton = document.querySelector(`.navbar-search`);
const searchCollapse = document.querySelector(`.search-collapse`);
const searchHeader = document.querySelector(`#search-header`);

function openSearch(event) {
  if (
    searchButton.contains(event.target) ||
    searchHeader.contains(event.target)
  ) {
    searchCollapse.style.display = `block`;
  } else {
    searchCollapse.style.display = `none`;
  }
}

if (searchButton) {
  document.addEventListener(`click`, openSearch);
}

/**
 * Sets the search button icon on the blog pages
 */

const searchForm = document.querySelector(
  `.wp-block-search__inside-wrapper > .wp-block-search__input`
);
const searchSubmit = document.querySelector(
  `.wp-block-search__inside-wrapper > .wp-block-search__button`
);

if (searchForm) {
  searchSubmit.setAttribute(`id`, `searchsubmit`);

  const setSearchButtonIcon = (screenWidth) => {
    if (screenWidth <= 769) {
      searchSubmit.innerHTML = ``;
      searchSubmit.insertAdjacentHTML(
        `beforeend`,
        ` <i class="bi bi-search"></i>`
      );
    } else {
      searchSubmit.innerHTML = ``;
      searchSubmit.innerHTML = `Search `;
      searchSubmit.insertAdjacentHTML(
        `beforeend`,
        ` <i class="bi bi-chevron-right"></i>`
      );
    }
  };

  const getWindowWidth = () => {
    const screenWidth = window.innerWidth;
    setSearchButtonIcon(screenWidth);
  };

  let timeout = false;
  window.addEventListener(`load`, getWindowWidth);
  window.addEventListener(`resize`, () => {
    clearTimeout(timeout);
    timeout = setTimeout(getWindowWidth, 100);
  });
}
